import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ExportHalfYearlyPDF = ({
  student,
  standardLabel,
  divisionLabel,
  marksData,
}) => {
  const doc = new jsPDF("p", "mm", "a4");

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("SHRADHANAND BAL MANDIR SENIOR SECONDARY SCHOOL", 105, 15, {
    align: "center",
  });

  doc.setFontSize(11);
  doc.text("PROGRESS REPORT", 105, 22, { align: "center" });
  doc.text("Half Yearly Examination (2023–24)", 105, 28, {
    align: "center",
  });

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Student Name : ${student?.name || ""}`, 14, 38);
  doc.text(`Class : ${standardLabel}`, 14, 44);
  doc.text(`Section : ${divisionLabel}`, 70, 44);
  doc.text(`Roll No : ${student?.roll || ""}`, 140, 44);

  const head = [
    [
      { content: "Subject", rowSpan: 2 },
      {
        content: "Internal Assessment",
        colSpan: 5,
        styles: { halign: "center" },
      },
      { content: "Half Yearly", colSpan: 2, styles: { halign: "center" } },
    ],
    [
      "PT-1",
      "PT-2",
      "Class Work",
      "Home Work",
      "Sub Enrichment",
      "Marks",
      "Grade",
    ],
  ];

  const body = marksData.map((row) => [
    row.subjectName,
    row.pt1,
    row.pt2,
    row.classWork,
    row.homeWork,
    row.subEnrichment,
    row.halfYearly,
    row.grade,
  ]);

  autoTable(doc, {
    head,
    body,
    startY: 55,
    theme: "grid",
    styles: { fontSize: 9, halign: "center" },
    columnStyles: { 0: { halign: "left" } },
  });

  const finalY = doc.lastAutoTable.finalY + 20;
  doc.text("Class Teacher Sign", 14, finalY);
  doc.text("Principal Sign", 150, finalY);

  doc.save(`${student?.name || "Student"}_Half_Yearly_Report.pdf`);
};

export default ExportHalfYearlyPDF;
